import { type IconProps } from 'components/Shared/Icon/index';
import { iconStyles } from 'components/Shared/Icon/iconStyles';
import styles from './styles.scss';
import cn from 'classnames';

export const IconSvea = (props: IconProps) => (
  <svg
    viewBox="0 0 400 260"
    xmlns="http://www.w3.org/2000/svg"
    className={cn(iconStyles(props), styles.removeStroke)}
  >
    <path
      d="m106.16 113.3h-18.77c-6.81 0-7.57-3.33-7.57-6.05 0-5.3 2.72-7.57 9.54-7.57h36.33v-14.53h-38.44c-16.95 0-24.97 6.96-24.97 22.1 0 14.08 7.57 20.74 23.76 20.74h16.8c6.51 0 8.78 1.51 8.78 6.51 0 4.09-1.51 6.21-9.69 6.21h-36.93v14.68h39.2c16.95 0 24.97-6.81 24.97-21.49s-6.66-20.58-23.01-20.58zm80.07-28.16-19.83 48.13-19.53-48.13h-19.07l30.73 70.23h16.35l29.36-70.23zm47.37 14.38h24.67v-14.38h-24.97c-22.55 0-33.15 11.5-33.15 36.33 0 12.87 3.63 21.8 10.9 27.7 7.27 5.75 14.23 6.21 21.95 6.21h25.28v-14.53h-24.67c-10.14 0-14.23-3.78-14.68-13.77h39.35v-14.38h-39.2c.91-8.93 5.6-13.17 14.53-13.17zm57.37-14.38-29.67 70.23h18.01l6.05-16.04h27.4l6.21 16.04h18.77l-29.97-70.23zm-.16 39.36 7.87-20.89 8.17 20.89z"
      fill="#002c50"
    />
    <path
      d="m67.86 168.69h266.39c1.82 0 3.33 1.51 3.33 3.33v11.5c0 1.82-1.51 3.33-3.33 3.33h-266.39c-1.82 0-3.33-1.51-3.33-3.33v-11.5c0-1.82 1.51-3.33 3.33-3.33z"
      fill="#00aece"
    />
  </svg>
);
